module.exports = __webpack_public_path__ + "img/เครื่องผสมอาหาร.b6f3124a.png";